import { render, staticRenderFns } from "./FilterTagsAssistance.vue?vue&type=template&id=37b19c79&"
import script from "./FilterTagsAssistance.vue?vue&type=script&lang=js&"
export * from "./FilterTagsAssistance.vue?vue&type=script&lang=js&"
import style0 from "./FilterTagsAssistance.vue?vue&type=style&index=0&id=37b19c79&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports